import { ForecastChartSection } from './ForecastChartSection';
import { ForecastParameterCard } from './ForecastParameterCard';
import { ForecastResultsSection } from './ForecastResultsSection';

export const Forecast = {
    ChartSection: ForecastChartSection,
    ParameterCard: ForecastParameterCard,
    ResultsSection: ForecastResultsSection,
};
